import { account } from './account';
import { billing } from './billing';
import { common } from './common';
import { dashboard } from './dashboard';
import { error } from './error';
import { games } from './games';
import { gamesUi } from './games-ui';
import { landing } from './landing';
import { legal } from './legal';
import { layout } from './layout';
import { matchmaking } from './matchmaking';
import { modals } from './modals';
import { onboard } from './onboard';
import { subscriptions } from './subscriptions';
import { ui } from './ui';

export const en = {
  account,
  billing,
  common,
  dashboard,
  error,
  games: {
    ui: gamesUi,
    ...games,
  },
  landing,
  legal,
  layout,
  matchmaking,
  modals,
  onboard,
  subscriptions,
  ui,
};
